// =============================================
// navigationService.ts
// =============================================

import { apiClient } from "../api/apiClient";

// =============================================
// API URL
// =============================================

const API_URL = "/NavigationMenus";

// =============================================
// TYPES
// =============================================

export interface NavChild {

  subMenuID?: number;

  menuID?: number;

  subMenuName: string;

  subMenuUrl: string;

  targetType: "_self" | "_blank";

  status: "Active" | "Hidden";

  displayOrder: number;

  isActive?: boolean;
}

export interface NavItem {

  menuID?: number;

  menuName: string;

  menuUrl: string;

  targetType: "_self" | "_blank";

  status: "Active" | "Hidden";

  displayOrder: number;

  isActive?: boolean;

  navigationSubMenus: NavChild[];
}

// =============================================
// API METHODS
// =============================================

export const navigationService = {

  // =============================================
  // GET ALL
  // =============================================

  getAll: async () => {

    const response =
      await apiClient.get(
        `${API_URL}/GetAll`
      );

    return response.data;
  },

  // =============================================
  // GET BY ID
  // =============================================

  getById: async (
    id: number
  ) => {

    const response =
      await apiClient.get(
        `${API_URL}/GetById/${id}`
      );

    return response.data;
  },

  // =============================================
  // CREATE
  // =============================================

  create: async (
    payload: NavItem
  ) => {

    const response =
      await apiClient.post(
        `${API_URL}/Create`,
        payload
      );

    return response.data;
  },

  // =============================================
  // UPDATE
  // =============================================

  update: async (
    payload: NavItem
  ) => {

    const response =
      await apiClient.put(
        `${API_URL}/Update`,
        payload
      );

    return response.data;
  },

  // =============================================
  // DELETE
  // =============================================

  delete: async (
    id: number
  ) => {

    const response =
      await apiClient.delete(
        `${API_URL}/Delete/${id}`
      );

    return response.data;
  }
};